module.exports = __webpack_public_path__ + "img/6.c937c021.png";